import { NavLink } from "react-router-dom";
// component thanh điều hướng trong giỏ hàng
const CartNav = (props) => {
  return (
    <div className="cart_nav_wrap">
      <NavLink to="/products" className="cart_nav_icon">
        &larr; Back
      </NavLink>
      {props.totalPrice > 0 ? (
        <NavLink to="/checkout" className="cart_nav_icon">
          Order &rarr;
        </NavLink>
      ) : (
        <span></span>
      )}
    </div>
  );
};

export default CartNav;
